var map = {
	"./star-1.svg": "./src/assets/images/fast-tracking/utils/stars/red/star-1.svg",
	"./star-2.svg": "./src/assets/images/fast-tracking/utils/stars/red/star-2.svg",
	"./star-3.svg": "./src/assets/images/fast-tracking/utils/stars/red/star-3.svg",
	"./star-4.svg": "./src/assets/images/fast-tracking/utils/stars/red/star-4.svg",
	"./star-5.svg": "./src/assets/images/fast-tracking/utils/stars/red/star-5.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/fast-tracking/utils/stars/red sync recursive ^\\.\\/star\\-.*\\.svg$";